import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "08705558-0d3b-419f-af39-520120ab4ca7",
    content: "It is better to leave the entire sound system on.",
    options: {},
  },
  {
    id: "79b794b5-9cad-4588-8538-f86eaef5a85a",
    content: "It is better to switch off the part of the sound system on the empty side of the visitor area.",
    options: {},
  },
  {
    id: "26212a0b-38a7-40ee-9944-c35d3233abb0",
    content: "Either solution is good, because it does not matter how many loudspeakers are in operation.",
    options: {},
  },
];

export const task: Task = {
  id: "58e9786a-6a6a-4585-926e-6eb0b32358a4",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: false,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["79b794b5-9cad-4588-8538-f86eaef5a85a"],
};
